// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'

import HealthList from 'syft-acp-core/entities/HealthList'
import PageView from 'syft-acp-core/components/PageView'
import SubNavigationWatchlist from './SubNavigation'

export const WatchlistHealthQuestionnaires = () => (
  <>
    <SubNavigationWatchlist />
    <PageView title={['Watchlist', 'Positive answers to health questionnaires']} entityPage>
      <HealthList />
    </PageView>
  </>
)
